export default __webpack_public_path__ + "static/images/platform1.d5824da7.jpg";